import React from 'react'
// import PeripheralRow from './peripheralRow'
import './peripheralList.css'

class PeripheralList extends React.Component {


    render() {
        let tableStyle = {
            textAlign: "left",
            width: "100%"
        };
        return (
            <table style={tableStyle}>
                <tbody>
                    {this.props.children}
                </tbody>
            </table>
        );
    }
}

export default PeripheralList;
